import { render, staticRenderFns } from "./NavSideMenuOverlay.vue?vue&type=template&id=49de70e2&"
import script from "./NavSideMenuOverlay.vue?vue&type=script&lang=js&"
export * from "./NavSideMenuOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports